import { Box, Button, Group, Image, Notification, Stack, Text, ThemeIcon } from '@mantine/core'
import { Consts, useGlobalState } from '@opsopti/shared'
import appIcon from '@opsopti/shared/src/assets/icon.ios.png'
import { IconBrandAndroid, IconBrandApple } from '@tabler/icons-react'
import { observer } from 'mobx-react-lite'

import { theme } from '@/configs/theme'
import { getUserAgentPlatform } from '@/utils/userAgent'

export const MobileAppBanner = observer(function MobileAppBanner() {
  const { uiStore } = useGlobalState()
  const platform = getUserAgentPlatform()

  if (!platform || uiStore.showAppBanner === false) return null

  const isIos = platform === 'ios'
  const link = isIos ? Consts.iosAppLink : Consts.androidAppLink
  const Icon = isIos ? IconBrandApple : IconBrandAndroid
  const color = isIos ? theme.colors.blue[9] : theme.colors.lime[9]

  return (
    <Notification
      color={color}
      withCloseButton
      withBorder
      onClose={() => uiStore.setProp('showAppBanner', false)}
      styles={{
        root: {
          position: 'fixed',
          zIndex: 9999,
          top: '2dvw',
          left: '2dvw',
          right: '2dvw',
          padding: theme.spacing.lg,
        },
        body: {
          overflow: 'visible',
        },
        description: {
          overflow: 'visible',
        },
      }}>
      <Group wrap="nowrap" gap="xl">
        <Box pos="relative">
          <Image src={appIcon} h={theme.rem(80)} w={theme.rem(80)} fit="cover" radius="lg" />
          <ThemeIcon variant="filled" color={color} size={36} radius={36} pos="absolute" right={-12} top={-12}>
            <Icon color="white" />
          </ThemeIcon>
        </Box>
        <Stack gap={0}>
          <Text fw="bold" size="lg">
            OpsOpti
          </Text>
          <Text mb={5}>Get on the {isIos ? 'App' : 'Play'} Store</Text>
          <Button size="compact-xs" color={color} component={'a'} href={link} target="_blank" maw={100}>
            GET
          </Button>
        </Stack>
      </Group>
    </Notification>
  )
})
